const HomeIcon = ({ active = false }: { active?: boolean }) => {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_359_754)">
                <path
                    d="M23.3529 11.1576C23.3524 11.157 23.3518 11.1565 23.3513 11.1559L13.5612 1.36621C13.1439 0.94873 12.5891 0.71875 11.9989 0.71875C11.4088 0.71875 10.854 0.948547 10.4365 1.36603L0.651514 11.1508C0.648218 11.1541 0.644922 11.1576 0.641626 11.1609C-0.215307 12.0228 -0.213843 13.4211 0.645838 14.2808C1.0386 14.6738 1.55734 14.9014 2.11196 14.9252C2.13449 14.9274 2.15719 14.9285 2.18008 14.9285H2.57028V22.1331C2.57028 23.5588 3.73025 24.7188 5.15627 24.7188H8.98647C9.37466 24.7188 9.6896 24.404 9.6896 24.0156V18.3672C9.6896 17.7166 10.2188 17.1874 10.8693 17.1874H13.1285C13.7791 17.1874 14.3083 17.7166 14.3083 18.3672V24.0156C14.3083 24.404 14.623 24.7188 15.0114 24.7188H18.8416C20.2676 24.7188 21.4276 23.5588 21.4276 22.1331V14.9285H21.7894C22.3794 14.9285 22.9342 14.6987 23.3518 14.2812C24.2124 13.42 24.2128 12.0193 23.3529 11.1576Z"
                    fill={active ? "white" : "#636363"}
                />
            </g>
            <defs>
                <clipPath id="clip0_359_754">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.71875)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default HomeIcon;
